export default {
    "name": "AddChartToReportMutation",
    "kind": "HoudiniMutation",
    "hash": "25aa43ef9a22c940587009eafc509e2833c8b06bc5fa8ffd14851174694d8f63",

    "raw": `mutation AddChartToReportMutation($input: AddChartToDashboardReportInput!) {
  addChartToDashboardReport(input: $input) {
    chartId: id
    showChart: display
    inReport
    rank
    supertype
    title
    chartType: type
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "addChartToDashboardReport": {
                "type": "DashboardChart",
                "keyRaw": "addChartToDashboardReport(input: $input)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "chartId": {
                            "type": "Int",
                            "keyRaw": "chartId",
                            "visible": true
                        },

                        "showChart": {
                            "type": "Boolean",
                            "keyRaw": "showChart",
                            "visible": true
                        },

                        "inReport": {
                            "type": "Boolean",
                            "keyRaw": "inReport",
                            "nullable": true,
                            "visible": true
                        },

                        "rank": {
                            "type": "Int",
                            "keyRaw": "rank",
                            "nullable": true,
                            "visible": true
                        },

                        "supertype": {
                            "type": "DashboardChartSupertype",
                            "keyRaw": "supertype",
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "chartType": {
                            "type": "String",
                            "keyRaw": "chartType",
                            "nullable": true,
                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "AddChartToDashboardReportInput"
        },

        "types": {
            "AddChartToDashboardReportInput": {
                "chartId": "Int",
                "jsonOverride": "String",
                "rank": "Int",
                "reportId": "Int"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=1a461c6f8d10ddd59865d22b09857da3fe9307193d7717d27281f49fac2daa19";